import { Pipe, PipeTransform } from "@angular/core";

// Turns a data key into a header label: "basicName" -> "Basic Name",
// "contact_Email" -> "Contact Email", "assetModel" -> "Asset Model".
@Pipe({
  name: "columnLabel",
  standalone: false,
})
export class ColumnLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return "";
    }
    return value
      .replace(/_/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }
}
